import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useCustomerOptions } from '@/hooks/useCustomerOptions';
import type { CustomerResponse } from '@/types/customer';

export interface CustomerSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onCustomerChange?: (customer: CustomerResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  showDetails?: boolean;
  name?: string;
}

export function CustomerSelect({
  label = 'Customer',
  value = '',
  onChange,
  onCustomerChange,
  placeholder = 'Select customer',
  disabled,
  className,
  required,
  error,
  showDetails: _showDetails = true,
  name,
}: CustomerSelectProps) {
  const { options, loading, getCustomer } = useCustomerOptions();

  const handleChange = (next: string) => {
    onChange?.(next);
    onCustomerChange?.(next ? getCustomer(next) ?? null : null);
  };

  return (
    <div className={className}>
      <SearchableSelect
        label={label}
        name={name}
        required={required}
        error={error}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        searchPlaceholder="Search customers…"
        emptyMessage="No customers found"
      />
    </div>
  );
}
